var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BehaviorSubject } from 'rxjs';
import { ApiService } from '../api/api.service';
import { tap } from 'rxjs/operators';
var ShoplistService = /** @class */ (function () {
    function ShoplistService(api) {
        this.api = api;
        this.defaultState = {
            shoplist: {
                active: null,
                createdAt: null,
                dates: null,
                id: null,
                otherItems: [],
                shoplistCategoryItems: []
            },
            status: null
        };
        this.state = this.defaultState;
        this.shoplistSubject = new BehaviorSubject(this.state);
    }
    ShoplistService.prototype.setState = function (newState) {
        this.state = __assign({}, this.state, newState);
        this.shoplistSubject.next(this.state);
    };
    ShoplistService.prototype.getState = function () {
        return this.shoplistSubject;
    };
    ShoplistService.prototype.getShoplist = function (forceFetch) {
        if (forceFetch === void 0) { forceFetch = false; }
        if (forceFetch || !this.state.status) {
            if (!this.isLoading) {
                this.getShoplistLatest().subscribe();
            }
        }
        return this.shoplistSubject;
    };
    ShoplistService.prototype.getShoplistLatest = function () {
        var _this = this;
        this.isLoading = true;
        return this.api.shoplist.getShoplist().pipe(tap(function (shoplist) { return _this.setState(shoplist); }), tap(function () { return (_this.isLoading = false); }));
    };
    ShoplistService.prototype.createShoplist = function (dates) {
        return this.api.shoplist.createShoplist({ dates: dates });
    };
    ShoplistService.prototype.deactivateShoplist = function () {
        this.setState(this.defaultState);
        return this.api.shoplist.deactivateShoplist();
    };
    ShoplistService.prototype.addOtherItem = function (request) {
        var _this = this;
        return this.api.shoplist.addOtherItem(request).pipe(tap(function (shoplist) { return _this.setState(shoplist); }));
    };
    ShoplistService.prototype.removeOtherItem = function (request) {
        var _this = this;
        return this.api.shoplist.removeOtherItem(request).pipe(tap(function (shoplist) { return _this.setState(shoplist); }));
    };
    ShoplistService.prototype.checkShoplistIngredient = function (request) {
        var _this = this;
        if (request.ingredientId) {
            this.updateShoplistIngredient(request);
        }
        return this.api.shoplist.checkShoplistIngredient(request).pipe(tap(function () {
            if (request.ingredientIds) {
                _this.getShoplistLatest().subscribe();
            }
        }));
    };
    ShoplistService.prototype.checkOtherItem = function (request) {
        this.updateShoplistOther(request);
        return this.api.shoplist.checkOtherItem(request);
    };
    ShoplistService.prototype.shareShoppingList = function (request) {
        return this.api.shoplist.shareShoppingList(request);
    };
    /* Creating shoplist */
    ShoplistService.prototype.addProfileToMeal = function (request) {
        return this.api.meal.addProfileToMeal(request);
    };
    ShoplistService.prototype.removeProfileFromMeal = function (request) {
        return this.api.meal.removeProfileFromMeal(request);
    };
    ShoplistService.prototype.getShoplistOptions = function () {
        return this.api.shoplist.getShoplistOptions();
    };
    /* Helpers */
    ShoplistService.prototype.updateShoplistIngredient = function (request) {
        var shoplistCategoryItems = this.state.shoplist.shoplistCategoryItems.map(function (shoplistCategoryItem) {
            var shoplistItems = shoplistCategoryItem.shoplistItems.map(function (shoplistItem) {
                var checked = request.ingredientId === shoplistItem.ingredient.id ? request.checked : shoplistItem.checked;
                return __assign({}, shoplistItem, { checked: checked });
            });
            return __assign({}, shoplistCategoryItem, { shoplistItems: shoplistItems });
        });
        var shoplist = __assign({}, this.state.shoplist, { shoplistCategoryItems: shoplistCategoryItems });
        this.setState({ shoplist: shoplist });
    };
    ShoplistService.prototype.updateShoplistOther = function (request) {
        var otherItems = this.state.shoplist.otherItems.map(function (otherItem) {
            var checked = request.itemId === otherItem.id ? request.checked : otherItem.checked;
            return __assign({}, otherItem, { checked: checked });
        });
        var shoplist = __assign({}, this.state.shoplist, { otherItems: otherItems });
        this.setState({ shoplist: shoplist });
    };
    return ShoplistService;
}());
export { ShoplistService };
